import React from 'react';

const MetricsContext = React.createContext();
export default MetricsContext;
